import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'nonHomeCountryApplicationDesc'>;

type Params = Fields;

export function getPageStatus({ nonHomeCountryApplicationDesc }: Params): { complete: boolean } {
  let complete = false;
  if (nonHomeCountryApplicationDesc !== undefined) {
    if (nonHomeCountryApplicationDesc.length > 0) {
      complete = true;
    } else {
      complete = false;
    }
  }

  return { complete };
}
